import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../helpers/model.helper';
import { ITrackingAction, TrackingActionNamesEnum } from '../tracking.data';

export const TRACKING_DROPDOWN_TAPPED_SCHEMA = Object.freeze({
  DROPDOWN_IDENTIFIER: '',
  SCREEN_NAME: '',
});
const RECORD = generateSchema(TRACKING_DROPDOWN_TAPPED_SCHEMA);
const KEYS: any = generateKeys(TRACKING_DROPDOWN_TAPPED_SCHEMA);

export class DropdownTappedTrackingAction
  extends Record(RECORD)
  implements ITrackingAction {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingActionNamesEnum.dropdown_tapped;
  }

  get properties() {
    return this.toJS();
  }
}
